import { render, staticRenderFns } from "./OrderHistoryFA.vue?vue&type=template&id=bea5f36a&"
import script from "./OrderHistoryFA.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports